import { Observable } from "rxjs/Observable";
import * as actions from "./report.actions";
import { Report } from "./report.model";
import { Job } from "../job/job.model";
import { AccountObjectStoreFacade } from "../account-object/account-object.store-facade";
import { ActionOptionsArgs } from "../../../core/store/actions/base-actions";
import { Qry } from "../query-facade";

export class ReportStoreFacade extends AccountObjectStoreFacade<Report> {

    getAll(): Observable<Array<Report>> {
        return this.select(Qry.getInstance().report.items);
    }

    create(report: Report): void {
        this.dispatch(new actions.SubmitAction(report));

        this.appFacade.objects.job.store.get(report.job).take(1).subscribe(job => {
            this.appFacade.objects.job.store.attachReport(job, report);
        });
    }

    remove(report: Report, options?: ActionOptionsArgs): void {

        this.appFacade.objects.job.store.getAll().take(1).subscribe(jobs => {
            jobs.forEach(job => this.appFacade.objects.job.store.detachReport(job, report));
        });

        this.dispatch(new actions.RemoveAction(report, options));
    }

    update(report: Report): void {
        this.dispatch(new actions.SubmitAction(report));
    }

    insert(report: Report): void {
        this.dispatch(new actions.SubmitAction(report, {persistable: true, restful: false}));
    }

    removeByJob(job: Job, options?: ActionOptionsArgs): void {
        this.removeBy(file => file.id === job.id, options);
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/report/report.store-facade.ts